
import { FailureType ,IADPState} from "../typings";
import { ErrorButtons, ErrorPropsV2, Failure as Error, Wait,SplitLayout } from "@npd-ng/adp-component-library";
import { useDispatch, useSelector } from "react-redux";
import { createSetExitAction, createTryAgainAction } from "shared/state/reducer";
import errorTriangle from '../assets/red_triangle_exclamation.svg'
import { useState } from "react";
export default function FailureView() {
  const state = useSelector((state:{rootState:IADPState})=>state.rootState)
  const dispatch = useDispatch()
  const [wait,setWait] = useState(false)
  const content = useSelector((state:{rootState:IADPState})=>state.rootState.currentLanguageContent)
  const errorType:FailureType = state.sessionState.failure || "ApplicationError"
  const errorContent = useSelector((state:{rootState:IADPState})=>state.rootState.currentLanguageContent?.error[errorType])
  const handleExit = () =>{
    dispatch(createSetExitAction());
  } 
  const tryAgain =()=>{
    setWait(true);
    setTimeout(()=>{
      setWait(false);
      if(state.sessionState.lastKnownGoodState === "LoadingView"){
        window.location.reload();
      }
      else{
        dispatch(createTryAgainAction());
        }
    },2000)
  }
  const getButtonProps =(errorType:FailureType):ErrorButtons[] => {
    switch(errorType){
        case "ApplicationError" : 
        {
            return [
                    {
                        label: content?.actions.exit || "Exit Application",
                        action: handleExit,
                        variant: "secondary",
                        key:0
                    }
                ]
        }
        case "NoNCSConnectionDetected":
        case "NoRouterConnectionDetected":
        case "NoInternetConnectionDetected":
        case "NoServerConnectionDetected" : 
        {
            return [
                    {
                        label: content?.actions.tryAgain || "Try Again",
                        action: tryAgain,
                        variant: "primary",
                        key:0
                    },
                    {
                        label: content?.actions.exit || "Exit Application",
                        action: handleExit,
                        variant: "secondary",
                        key:1
                    }
                ]
        }
        case "FailedHardwareCheck" : 
        case "SystemError" : 
        case "UpdateError" : 
        case "FailedVersionCheck" : 
        case "FailedSystemTimeCheck" : 
        case "ProccessCheckError" :
        {
            return [
                    {
                        label: content?.actions.exit || "Exit Application",
                        action: handleExit,
                        variant: "secondary",
                        key:0
                    }
                ]
        }
    }
  }
  const errorProps:ErrorPropsV2 ={
    iconSrc:errorTriangle,
    title:errorContent?.title || "",
    content:errorContent?.content || [],
    buttons:getButtonProps(errorType),
    errorCode:errorContent?.errorCode,
    alt:state.currentLanguageContent?.imageAltText.failureTriangleIcon as string

  }
  return (
    <SplitLayout logoAlt={state.currentLanguageContent?.imageAltText.naepLogo as string}>
       {wait && <Wait spinnerAlt={state.currentLanguageContent?.imageAltText.verifyingIcon as string}/>} 
       {!wait && <Error {...errorProps}/>}
    </SplitLayout>
  )       
}
